import { useEffect, useState, useRef } from 'react'
import { MapContainer, TileLayer, WMSTileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster'
import UserPositionMarker from './UserPositionMarker'
import WreckMarkerClusters from './WreckMarkerClusters'
import ControlButton from './ControlButton'
import OverlayLayers from './OverlayLayers'

const OpenSeaMapWithClusters = ({
  filteredWrecks,
  allWrecks,
  wreckId,
  fitMapToMarkers,
  setFitMapToMarkers,
  visibilityState,
  clearAll,
  setClearAll,
}) => {
  const [loading, setLoading] = useState(true)
  const [showAllWrecks, setShowAllWrecks] = useState(false)
  const prevShowAllWrecks = useRef(showAllWrecks)
  const [overlayLayers, setOverlayLayers] = useState([
    {
      name: 'Traficom Merikartta',
      tag: 'traficom',
      checked: false,
      minZoom: 11,
      layer: (
        <WMSTileLayer
          layers="cells"
          url="https://julkinen.traficom.fi/s57/wms"
          transparent
          format="image/png"
          minZoom={11}
          attribution="CCBY4.0 Traficom"
        />
      ),
    },
    {
      name: 'OpenSeaMap',
      tag: 'openSeaMap',
      checked: false,
      layer: (
        <TileLayer
          url="https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png"
          attribution="&copy; OpenSeaMap contributors"
        />
      ),
    },
  ])

  const prevOverlayLayers = useRef(overlayLayers)

  useEffect(() => {
    Object.keys(window.localStorage).forEach((item) => {
      if (item.includes('overlay')) {
        setOverlayLayers((prev) =>
          prev.map((overlay) =>
            item.includes(overlay.name.replace(' ', '_')) ? { ...overlay, checked: true } : overlay,
          ),
        )
        prevOverlayLayers.current = prevOverlayLayers.current.map((overlay) =>
          item.includes(overlay.name.replace(' ', '_')) ? { ...overlay, checked: true } : overlay,
        )
      }
    })
  }, [])

  useEffect(() => {
    Object.entries(window.sessionStorage).forEach(([key, value]) => {
      if (key === 'show_all_wrecks') {
        setShowAllWrecks(value === 'true')
        prevShowAllWrecks.current = value === 'true'
      }
    })
  }, [])

  const areMapOptionsToggled = () => {
    const isShowAllWreckToggled = () => {
      return prevShowAllWrecks.current !== showAllWrecks
    }

    const isOverlayChanged = () => {
      return prevOverlayLayers.current.some((prevLayer) =>
        overlayLayers.some((layer) => prevLayer.name === layer.name && prevLayer.checked !== layer.checked),
      )
    }

    if (isShowAllWreckToggled()) {
      prevShowAllWrecks.current = showAllWrecks
      return true
    }
    if (isOverlayChanged()) {
      prevOverlayLayers.current = overlayLayers
      return true
    }
    return false
  }

  useEffect(() => {
    setLoading(false)
  }, [filteredWrecks, allWrecks, wreckId, fitMapToMarkers, setFitMapToMarkers])

  if (loading) return <div>Loading map...</div>
  if (visibilityState) return <div></div>

  return (
    <MapContainer center={[50, 10]} zoom={4} style={{ height: '570px', width: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <OverlayLayers overlayLayers={overlayLayers} setOverlayLayers={setOverlayLayers} />
      <ControlButton showAllWrecks={showAllWrecks} setShowAllWrecks={setShowAllWrecks} />

      <WreckMarkerClusters
        wrecksToShow={showAllWrecks ? allWrecks : filteredWrecks}
        filteredWrecks={filteredWrecks}
        allWrecks={allWrecks}
        wreckId={wreckId}
        fitMapToMarkers={fitMapToMarkers}
        areMapOptionsToggled={areMapOptionsToggled()}
        clearAll={clearAll}
        setClearAll={setClearAll}
        merikarttaLayer={overlayLayers[0]}
      />
      <UserPositionMarker />
    </MapContainer>
  )
}

export default OpenSeaMapWithClusters
